import type { AuthProvider } from '../interfaces';

export const SSOProvider: Record<string, AuthProvider> = {
  Google: 'Google',
  Okta: { custom: 'ACTransit' },
};
